<div class="p-5">

    <!-- <a [routerLink]="" (click)="runQueryRunner()" style="cursor: pointer">run query runner</a> -->

    <h5>Dev Helper</h5>
    <hr>

    <div><button class="btn btn-sm btn-info" (click)="fiscalYearUpdate();">Fiscal Year Update</button></div>

    <div><button class="btn btn-sm btn-info" (click)="sanitizeField();">Sanitize Box Dates</button></div>

    <div><button class="btn btn-sm btn-info" (click)="api.syncFiscalYearINDN()">Sync Fiscal Year IN => DN</button></div>

    <div><button class="btn btn-sm btn-info" (click)="api.migrateCartonBoxPacking()">Migrate CartonBox => PackingSpecs</button></div>

    <!-- <div><button class="btn btn-sm btn-info" (click)="api.convertProfitMarginText()">Convert Legacy Profit Margin Text</button></div> -->

    <div><button class="btn btn-sm btn-info" (click)="showmongohelper = !showmongohelper">Mongodump Helper</button></div>
    <div *ngIf="showmongohelper">
        <ngx-dump-viewer></ngx-dump-viewer>
    </div>

    <div><button class="btn btn-sm btn-info" (click)="api.sendInventoryMonthlyReport()">Send Monthly Inventory Report</button></div>

    <div><button class="btn btn-sm btn-info" (click)="showdebuglog = !showdebuglog">Debug Log</button></div>
    <ng-container *ngIf="showdebuglog">
        <div class="row">
            <div class="m-2">
                Date From:
                <ngx-doc-form-date [(value)]="fromDate" (valueChange)="loadDebug()"></ngx-doc-form-date>
                Date To:
                <ngx-doc-form-date [(value)]="toDate" (valueChange)="loadDebug()"></ngx-doc-form-date>
            </div>
            <div class="pt-4">
                <button class="btn btn-sm btn-info" (click)="loadDebug()">reload</button>
            </div>
        </div>
    
        <table class="nrk-table debugTable">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Date</th>
                    <th>User</th>
                    <th>Type</th>
                    <th>Subject</th>
                    <th>Data</th>
                </tr>
                <tr>
                    <th></th>
                    <th></th>
                    <th>
                        <ngx-doc-form-dropdown [(value)]="search.user" [options]="userOptions" (valueChange)="setFilteredDebugData()"></ngx-doc-form-dropdown>
                    </th>
                    <th>
                        <ngx-doc-form-dropdown [(value)]="search.type" [options]="debugTypeOptions" (valueChange)="setFilteredDebugData()"></ngx-doc-form-dropdown>
                    </th>
                    <th><ngx-doc-form-texfield [(value)]="search.subject" (valueChange)="setFilteredDebugData()"></ngx-doc-form-texfield></th>
                    <th><ngx-doc-form-texfield [(value)]="search.data" (valueChange)="setFilteredDebugData()"></ngx-doc-form-texfield></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let debug of filteredDebugData">
                    <td>{{debug.id}}</td>
                    <td>{{debug.date | date : "yy-MM-dd HH:mm:ss.SSS"}}</td>
                    <td>{{getUser(debug.user)}}</td>
                    <td>{{debugType[debug.type]}}</td>
                    <td>{{debug.subject}}</td>
                    <ng-container [ngSwitch]="debug.type">
    
                        <td *ngSwitchCase="debugType.console" class="debug-data">
                            <button class="nrk-button" (click)="$any(debug).showDetails = !$any(debug).showDetails">toggle log</button>
                            <ng-container *ngIf="$any(debug).showDetails">
                                <br>
                                <ng-container *ngFor="let item of debug.data; let last = last">
                                    {{ item }}<br *ngIf="!last">
                                </ng-container>
                            </ng-container>
                        </td>
    
                        <td *ngSwitchCase="debugType.frontend" class="debug-data">
                            {{debug.data.msg}}<br>
                            <button class="nrk-button" (click)="$any(debug).showDetails = !$any(debug).showDetails">toggle stack</button>
                            <ng-container *ngIf="$any(debug).showDetails">
                                <table>
                                    <tr *ngFor="let item of debug.data.stack; let last = last">
                                        <ng-container *ngIf="item.functionName"><td>{{item.functionName}}</td><td>{{item.fileName}} [{{item.lineNumber}}][{{item.columnNumber}}]</td></ng-container>
                                        <td *ngIf="!item.functionName">{{item}}</td>
                                    </tr>
                                </table>
                            </ng-container>
                        </td>
    
                        <!-- <td *ngSwitchCase="[debugType.log, debugType.backend].includes(debug.type) ? debug.type : ''" class="log-data debug-data"> -->
                        <td *ngSwitchDefault class="log-data debug-data">
    
                            <div *ngIf="getLogData(debug.data)?.short && !$any(debug).showDetails; else logData">
                                <button class="nrk-button" (click)="$any(debug).showDetails = !$any(debug).showDetails">expand</button>
                                {{getLogData(debug.data).short}}
                            </div>
                            <ng-template #logData>
                                <div>
                                    {{getLogData(debug.data).res}}
                                </div>
                            </ng-template>
                        </td>
    
                        <!-- <td *ngSwitchDefault>
                            {{debug.data}}
                        </td> -->
    
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </ng-container>
    <hr>

</div>
